'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dUtil$0024 from "./mealorama.-Util$.js";
var $p;
/** @constructor */
function $c_Lmealorama_Ingredient(id_$_lo, id_$_hi, recipeId_$_lo, recipeId_$_hi, unit, amount, rangeamount, item, ingredientGroup, groceryItem, position, optional, original) {
  this.mS = 0;
  this.mT = 0;
  this.nV = 0;
  this.nW = 0;
  this.jb = null;
  this.hK = null;
  this.nl = null;
  this.jZ = null;
  this.ni = null;
  this.hl = null;
  this.oB = 0;
  this.nj = false;
  this.nk = null;
  this.mS = id_$_lo;
  this.mT = id_$_hi;
  this.nV = recipeId_$_lo;
  this.nW = recipeId_$_hi;
  this.jb = unit;
  this.hK = amount;
  this.nl = rangeamount;
  this.jZ = item;
  this.ni = ingredientGroup;
  this.hl = groceryItem;
  this.oB = position;
  this.nj = optional;
  this.nk = original;
}
export { $c_Lmealorama_Ingredient as $c_Lmealorama_Ingredient };
$p = $c_Lmealorama_Ingredient.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_Ingredient;
/** @constructor */
function $h_Lmealorama_Ingredient() {
}
export { $h_Lmealorama_Ingredient as $h_Lmealorama_Ingredient };
$h_Lmealorama_Ingredient.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, 1787055601);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.mS, this.mT)));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.nV, this.nW)));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.jb));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.hK));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.nl));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.jZ));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.ni));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.hl));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, this.oB);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.nj ? 1231 : 1237));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.nk));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 11);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_Ingredient)) {
    if (((this.oB === x$0.oB) && (this.nj === x$0.nj))) {
      var x_$_lo = this.mS;
      var x_$_hi = this.mT;
      var $x_8 = x$0;
      var x$1_$_lo = $x_8.mS;
      var x$1_$_hi = $x_8.mT;
      var $x_7 = (((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0);
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$2_$_lo = this.nV;
      var x$2_$_hi = this.nW;
      var $x_9 = x$0;
      var x$3_$_lo = $x_9.nV;
      var x$3_$_hi = $x_9.nW;
      var $x_6 = (((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) === 0);
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$4 = this.jb;
      var x$2$1 = x$0.jb;
      var $x_5 = ((x$4 === null) ? (x$2$1 === null) : x$4.f(x$2$1));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$3$1 = this.hK;
      var x$4$1 = x$0.hK;
      var $x_4 = ((x$3$1 === null) ? (x$4$1 === null) : x$3$1.f(x$4$1));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$5 = this.nl;
      var x$6 = x$0.nl;
      var $x_3 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_3 = false;
    }
    if (($x_3 && (this.jZ === x$0.jZ))) {
      var x$7 = this.ni;
      var x$8 = x$0.ni;
      var $x_2 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.hl;
      var x$10 = x$0.hl;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$11 = this.nk;
      var x$12 = x$0.nk;
      return ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.q = (function() {
  return 11;
});
$p.r = (function() {
  return "Ingredient";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.mS, this.mT);
      break;
    }
    case 1: {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.nV, this.nW);
      break;
    }
    case 2: {
      return this.jb;
      break;
    }
    case 3: {
      return this.hK;
      break;
    }
    case 4: {
      return this.nl;
      break;
    }
    case 5: {
      return this.jZ;
      break;
    }
    case 6: {
      return this.ni;
      break;
    }
    case 7: {
      return this.hl;
      break;
    }
    case 8: {
      return this.oB;
      break;
    }
    case 9: {
      return this.nj;
      break;
    }
    case 10: {
      return this.nk;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
$p.m = (function() {
  var this$1 = this.hK;
  var $x_1 = (this$1.b() ? "" : $j_mealorama$002e$002dUtil$0024.$m_Lmealorama_Util$().a3B(this$1.i().bf.i2()));
  var this$3 = this.jb;
  return (((($x_1 + " ") + (this$3.b() ? "" : this$3.i())) + " ") + this.jZ);
});
function $isArrayOf_Lmealorama_Ingredient(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jE)));
}
export { $isArrayOf_Lmealorama_Ingredient as $isArrayOf_Lmealorama_Ingredient };
var $d_Lmealorama_Ingredient = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_Ingredient, "mealorama.Ingredient", ({
  jE: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_Ingredient as $d_Lmealorama_Ingredient };
//# sourceMappingURL=mealorama.-Ingredient.js.map
